import React from "react";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { updateStylesThunk } from "../../apps/styleSlice";
import { editStyleSchema } from "../../validations";

const EditStyles = ({ styleItem, onClose }) => {
    const dispatch = useDispatch();
    const id = styleItem?._id; // Ensure styleItem exists before accessing `_id`

    // Formik Hook
    const formik = useFormik({
        initialValues: {
            id:styleItem?._id,
            title: styleItem?.title || "",
            prompt: styleItem?.prompt || "",
            height: styleItem?.height || "",
            width: styleItem?.width || "",
            referenceImage: styleItem?.referenceImage || "",
            thumb: styleItem?.thumb || "",
        },
        enableReinitialize: true, // Ensures Formik updates when styleItem changes
        validationSchema: editStyleSchema,
        onSubmit: async (values) => {
            await dispatch(updateStylesThunk({ id, values }));
            onClose();
        },
    });

    return (
        <div className="container mx-auto p-6">
            <h2 className="text-2xl font-bold mb-4">Edit Style</h2>

            <form onSubmit={formik.handleSubmit} className="bg-white shadow-md rounded-lg p-6">
                {/* ID */}
                <div className="p-2 rounded mb-2 border" >
                    <strong>id:</strong> {formik.values.id}
                </div>
                {/* Title */}
                <div>

                    <label className="block text-gray-700">Title</label>
                    <input
                        type="text"
                        name="title"
                        value={formik.values.title}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="border p-2 w-full rounded-md mb-2"
                    />
                    {formik.touched.title && formik.errors.title && (
                        <span style={{ color: "red" }}>
                            <div>{formik.errors.title}</div>
                        </span>
                    )}
                </div>

                {/* Prompt */}
                <div>

                    <label className="block text-gray-700">Prompt</label>
                    <input
                        type="text"
                        name="prompt"
                        value={formik.values.prompt}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="border p-2 w-full rounded-md mb-2"
                    />
                    {formik.touched.prompt && formik.errors.prompt && (
                        <span style={{ color: "red" }}>
                            <div>{formik.errors.prompt}</div>
                        </span>
                    )}
                </div>

                {/* Height */}
                <div>

                    <label className="block text-gray-700">Height</label>
                    <input
                        type="text"
                        name="height"
                        value={formik.values.height}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="border p-2 w-full rounded-md mb-2"
                    />
                    {formik.touched.height && formik.errors.height && (
                        <span style={{ color: "red" }}>
                            <div>{formik.errors.height}</div>
                        </span>
                    )}
                </div>

                {/* Width */}
                <div>

                    <label className="block text-gray-700">Width</label>
                    <input
                        type="text"
                        name="width"
                        value={formik.values.width}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="border p-2 w-full rounded-md mb-2"
                    />
                    {formik.touched.width && formik.errors.width && (
                        <span style={{ color: "red" }}>
                            <div>{formik.errors.width}</div>
                        </span>
                    )}
                </div>

                {/* Image URL */}
                <div>

                    <label className="block text-gray-700">Reference Image</label>
                    <input
                        type="text"
                        name="referenceImage"
                        value={formik.values.referenceImage}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="border p-2 w-full rounded-md mb-2"
                    />
                    {formik.touched.referenceImage && formik.errors.referenceImage && (
                        <span style={{ color: "red" }}>
                            <div>{formik.errors.referenceImage}</div>
                        </span>
                    )}
                </div>

                {/* referenceImage Preview */}
                <div>

                    {formik.values.referenceImage && (
                        <img
                            src={formik.values.referenceImage}
                            alt="Inspiration"
                            className="w-40 h-40 object-cover rounded-md mb-4"
                        />
                    )}
                </div>

                {/* Thumbnail */}
                <div>

                    <label className="block text-gray-700">Thumbnail</label>
                    <input
                        type="text"
                        name="thumb"
                        value={formik.values.thumb}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className="border p-2 w-full rounded-md mb-2"
                    />
                    {formik.touched.thumb && formik.errors.thumb && (
                        <span style={{ color: "red" }}>
                            <div>{formik.errors.thumb}</div>
                        </span>
                    )}
                </div>

                {/* Thumb Preview */}
                <div>
                    {formik.values.thumb && (
                        <img
                            src={formik.values.thumb}
                            alt="Inspiration"
                            className="w-40 h-40 object-cover rounded-md mb-4"
                        />
                    )}

                </div>

                {/* Submit Button */}
                <button type="submit" className="bg-black text-white px-4 py-2 rounded-md">
                    Update Inspiration
                </button>
            </form>
        </div>
    );
};

export default EditStyles;
